import type { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconEnvelopeOpenText } from '@sorare/core/src/atoms/icons/system/iconEnvelopeOpenText.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { ANY_SPORT_SERIES_INBOX } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const InboxButton = ({ children }: PropsWithChildren) => {
  const { formatMessage } = useIntl();
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();

  const unclaimedTasksCount = currentUser?.unclaimedInboxTasksCount || 0;

  return (
    <ButtonBase
      to={generateSportContextPath(ANY_SPORT_SERIES_INBOX)}
      aria-label={formatMessage(navLabels.inbox)}
    >
      <Horizontal>
        <Badge badgeContent={unclaimedTasksCount} overlap="circular">
          <IconButton
            size="medium"
            icon={iconEnvelopeOpenText}
            color="transparent"
            asSpan
          />
        </Badge>
        {children}
      </Horizontal>
    </ButtonBase>
  );
};
